export const iconSize = {
    cursor: 'pointer',
    width: '30px',
    height: '30px',
    marginLeft: '1%',
    marginRight: '1%',
};
